import { render, staticRenderFns } from "./OrderSynatecTab.vue?vue&type=template&id=15369870&scoped=true&"
import script from "./OrderSynatecTab.vue?vue&type=script&lang=js&"
export * from "./OrderSynatecTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderSynatecTab.vue?vue&type=style&index=0&id=15369870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15369870",
  null
  
)

export default component.exports